<template>
<div>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <h1 class="text-xl font-bold">{{$t('form.se_connecter.authentification_requise')}}</h1>
        <p class="mt-2 mb-3 font-light">{{$t('form.se_connecter.vous_devez_etre_authentifie_afin_de_poursuivre_le_formulaire')}}</p>
        <button @click="end('login')" :class="$styleTool.isLight($styleTool.cssConf('defaultBgColor')) ? 'text-black' : 'text-white'" class="px-3 py-2 font-bold duration-100 border default-bg-color default-bg-color-hover:hover rounded-xl"> {{$t('form.se_connecter.se_connecter')}} </button>
        <button @click="end('register')" class="px-3 py-2 font-bold duration-100 bg-gray-200 hover:bg-gray-300 rounded-xl"> {{$t('form.se_connecter.s_inscrire')}} </button>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'login',
    extends: FormCardExtension,

    methods: {
        async init() {
        },
        end(next) {
            if (next == 'login') {
                this.$router.push({name: 'user.login', query: {next: 'form.home'}})
            } else {
                if (this.$companyTool.confFile().pro_particulier == '0') {
                    this.$router.push({name: 'user.register', query: {next: 'form.home'}})
                } else {
                    this.$router.push({name: 'user.login.actors', query: {next: 'form.home'}})
                }
            }
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/other/LoginCard.vue